import React from "react";
import ServiceCard from "./serviceCard";
import FilePreview from "../../../../component/renderFilePreview";

const STORE_HOURS_LABELS = new Set(["Store Hours", "Store hours"]);

function getStoreHoursRecord(data) {
  for (const key of STORE_HOURS_LABELS) {
    const v = data?.[key];
    if (v && typeof v === "object" && !Array.isArray(v)) return v;
  }
  return null;
}

function renderFieldValue(value) {
  if (value == null || value === "") return "-";
  if (typeof value === "object") {
    return Array.isArray(value) ? value.join(", ") : "—";
  }
  return value;
}

function TabSectionView({
  title = "Basic Information",
  icon: Icon,
  data = {},
  uploadDoc = [],
  services = [],
}) {
  const storeHours = getStoreHoursRecord(data);
  const isUploadedDocs =
    title === "Uploaded Document" || title === "Uploaded Documents";
  const isServicesSection =
    title === "Services Offerer" || title === "Services Offered";

  return (
    <div
      className=" w-full mx-2 bg-[#F9FAF7] rounded-[16px] shadow-md overflow-hidden"
      style={{ border: "2px solid #F1F1EF" }}
    >
      <div className="flex items-center h-[80px] font-[500] text-lg">
        <div className="flex justify-center items-center h-[40px] w-[40px] rounded-full bg-[#DFEEFF] mr-3 ml-4">
          {Icon && <Icon style={{ height: "20px", width: "20px" }} />}
        </div>
        {title}
      </div>
      {isUploadedDocs ? (
        <div className="flex gap-8 p-4 items-center flex-wrap rounded-[16px] bg-[#FFFFFF]">
          {uploadDoc.length > 0 ? (
            uploadDoc?.map((doc, index) => {
              const fileName = doc.name || `Document ${index + 1}`;
              return <FilePreview key={index} file={doc} fileName={fileName}/>;
            })
          ) : (
            <div className="text-gray-500 text-sm text-center w-full">
              No documents available.
            </div>
          )}
        </div>
      ) : isServicesSection ? (
        <div className="flex flex-wrap items-center p-4 gap-2 rounded-[16px] bg-[#FFFFFF]">
          {services.length > 0 ? (
            services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))
          ) : (
            <div className="text-gray-500 text-sm text-center w-full">
              No services available.
            </div>
          )}
        </div>
      ) : (
        <div className="h-full bg-[#FFFFFF] rounded-[30px] px-20">
          {Object.entries(data)
            .filter(([label]) => !STORE_HOURS_LABELS.has(label))
            .map(([label, value], idx, arr) => (
              <React.Fragment key={label}>
                <div className="flex w-full justify-between py-4 text-[14px]">
                  <div>{label}</div>
                  <div className="font-semibold text-right max-w-[60%]">
                    {renderFieldValue(value)}
                  </div>
                </div>
                {idx !== arr.length - 1 && (
                  <div className="border-dashed border w-full" />
                )}
              </React.Fragment>
            ))}
          {storeHours && (
            <>
              <div className="border-dashed border w-full my-4" />
              <div className="text-[14px] font-semibold mb-2 text-[#3383B2]">
                Store Hours
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs text-gray-700 pb-4">
                {Object.entries(storeHours).map(([day, times]) => {
                  const t =
                    times && typeof times === "object" ? times : {};
                  return (
                  <div
                    key={day}
                    className="flex flex-col border px-2 py-1 rounded-md"
                  >
                    <div className="flex justify-between">
                      <span className="capitalize">{day}</span>
                      {t.open && t.close ? (
                        <span>
                          {t.open} - {t.close}
                        </span>
                      ) : (
                        <span className="text-gray-400">Closed</span>
                      )}
                    </div>
                    {t.note && String(t.note).trim() !== "" && (
                      <div className="text-[10px] text-gray-500 mt-1 italic">
                        {t.note}
                      </div>
                    )}
                  </div>
                );
                })}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default TabSectionView;
